import React, { createContext, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import useService from '@/lib/hooks/useService';
import dayjs from 'dayjs';
import ProcessSteps from '../ProcessSteps';
import styles from './index.module.scss';
import type { ContextDefaultReservationType } from '../../types';
import type { CarServiceReservation } from '@/types/database/carService';

interface UpdateProcessButtonWithModalProps {
  reservation: ContextDefaultReservationType;
}

export const ReservationContext = createContext<ContextDefaultReservationType>({
  key: '',
  reservationTime: '',
  householdNumber: '',
  name: '',
  action: [],
});

const UpdateProcessButtonWithModal = ({
  reservation,
}: UpdateProcessButtonWithModalProps) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const [reservationData] = useService<CarServiceReservation>({
    collectionName: 'carService',
    query: { _id: reservation.key },
  });

  const { householdNumber, name } = reservation;

  const detailContent = [
    {
      title: '登記時間(年/月/日)',
      content: dayjs(reservationData[0]?.createdTime).format(
        'YYYY-MM-DD HH:mm'
      ),
    },
    {
      title: '預約乘車時間(年/月/日)',
      content: dayjs(reservationData[0]?.reservationTime).format(
        'YYYY-MM-DD HH:mm'
      ),
    },
    { title: '戶號', content: householdNumber },
    { title: '住戶', content: name },
  ];

  return (
    <>
      <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={<Button onClick={() => setIsOpenModal(false)}>確認</Button>}
      >
        <Space direction="vertical" className={styles.modalBodyContainer}>
          {detailContent.map((data) => {
            const { title, content } = data;
            return (
              <div key={title}>
                <h5 className={styles.fieldTitle}>{title}</h5>
                <p>{content}</p>
              </div>
            );
          })}
          <ReservationContext.Provider value={reservation}>
            <ProcessSteps />
          </ReservationContext.Provider>
        </Space>
      </Modal>
      <Button onClick={() => setIsOpenModal(true)}>新增進度</Button>
    </>
  );
};

export default UpdateProcessButtonWithModal;
